import { render } from "./riskList.vue?vue&type=template&id=e4070e0c&scoped=true"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"

import "./riskList.vue?vue&type=style&index=0&id=e4070e0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4070e0c"

export default script